import * as AppPics from 'assets/images';
import Icons from '../../assets/Icons';

function Html3() {
  return (
    <div className="mainWraper">
      <div className="tab app-l-tab_main">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back">
              <img src={AppPics.BackSvg} alt="" />
            </button>
          </li>
          <li className="active">
            Discover <span className="menuWrap__menuIndi">12</span>
          </li>
          <li className="">
            Assess<span className="menuWrap__menuIndi">8</span>
          </li>
          <li className="">
            Perform<span className="menuWrap__menuIndi">23</span>
          </li>
        </ul>
        <div className="tab__content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-6">
                <h2 className="prime-head p-0 boldtitle">Action Centre</h2>
              </div>
            </div>
            <div className="app-l-notes-wrapper">
              <div className="app-l-notes-wrapper_header">
                <div className="notes">Notes</div>
                <div className="notes_text">
                  <span className="menuWrap__menuIndi">12</span>Action(s) Pending
                </div>
                <div className="app-l-advanced-filters">
                  <select>
                    <option>Filter by User</option>
                    <option>Filter by User 1</option>
                    <option>Filter by User 2</option>
                    <option>Filter by User 3</option>
                    <option>Filter by User 4</option>
                    <option>Filter by User 5</option>
                  </select>
                  <a href="">Advanced Filters</a>
                </div>
              </div>
              <div className="app-l-notes-wrapper_body">
                <div className="app-l-notes-wrapper_body--items">
                  <div>
                    <span>
                      Plagiarism found in <strong>Lesson</strong> of <strong>Chapter</strong> from
                      <strong> Course</strong>
                    </span>
                    <div className="app-l-card-block">
                      <div className="as-level">AS Level</div>
                      <div className="AQA">AQA</div>
                      <div className="tag"></div>
                    </div>
                  </div>
                  <div className="time">Today, 4:38 PM</div>
                </div>
                <div className="app-l-notes-wrapper_body--items">
                  <div>
                    <span>
                      Plagiarism found in <strong>Lesson</strong> of <strong>Chapter</strong> from
                      <strong> Course</strong>
                    </span>
                    <div className="app-l-card-block">
                      <div className="as-level">AS Level</div>
                      <div className="AQA">AQA</div>
                      <div className="tag"></div>
                    </div>
                  </div>
                  <div className="time">Today, 4:38 PM</div>
                </div>
                <div className="app-l-notes-wrapper_body--items">
                  <div>
                    <span>
                      Plagiarism found in <strong>Lesson</strong> of <strong>Chapter</strong> from
                      <strong> Course</strong>
                    </span>
                    <div className="app-l-card-block">
                      <div className="as-level">AS Level</div>
                      <div className="AQA">AQA</div>
                      <div className="tag"></div>
                    </div>
                  </div>
                  <div className="time">Today, 4:38 PM</div>
                </div>
                <div className="app-l-notes-wrapper_body--items">
                  <div>
                    <span>
                      Plagiarism found in <strong>Lesson</strong> of <strong>Chapter</strong> from
                      <strong> Course</strong>
                    </span>
                    <div className="app-l-card-block">
                      <div className="as-level">AS Level</div>
                      <div className="AQA">AQA</div>
                      <div className="tag"></div>
                    </div>
                  </div>
                  <div className="time">Today, 4:38 PM</div>
                </div>
                <div className="app-l-notes-wrapper_body--items">
                  <div>
                    <span>
                      Plagiarism found in <strong>Lesson</strong> of <strong>Chapter</strong> from
                      <strong> Course</strong>
                    </span>
                    <div className="app-l-card-block">
                      <div className="as-level">AS Level</div>
                      <div className="AQA">AQA</div>
                      <div className="tag"></div>
                    </div>
                  </div>
                  <div className="time">Today, 4:38 PM</div>
                </div>
                <div className="app-l-notes-wrapper_body--items">
                  <div>
                    <span>
                      Plagiarism found in <strong>Lesson</strong> of <strong>Chapter</strong> from
                      <strong> Course</strong>
                    </span>
                    <div className="app-l-card-block">
                      <div className="as-level">AS Level</div>
                      <div className="AQA">AQA</div>
                      <div className="tag"></div>
                    </div>
                  </div>
                  <div className="time">Today, 4:38 PM</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Html3;
